

export default {
    HTTPREQUESTURL: `https://apiv3.dsjzg.cn`,
    // HTTPREQUESTURL: `http://develop.dsjzg.cn`,

    HEADER: {
        'jump':1,
		'content-type': 'application/json',
    },
	// 回话密钥名称 请勿修改此配置
	TOKENNAME: 'Authori-zation',
	// 缓存时间 0 永久
	EXPIRE: 0,
	//分页最多显示条数
	LIMIT: 10
}